<div class="copyfield" (click)="copyText()" (mouseenter)="setMarginOfInfoText()">
	<label>{{ label | translate }}</label>
	<span [innerHtml]="value" class="copyfield-value"></span>
	<span class="info" #copyfieldInfo [style.margin-left]="marginLeft">{{ copyInfo | translate }}</span>
</div>